import React from 'react';
import { Box, Typography } from '@mui/material';
import ModalDialog from '../ModalDialog/ModalDialog';
import JlrButton from '../JlrButton/JlrButton';
import { useResolutionScale } from '../../hooks/useResolutionScale';
import { DARK_MODE } from '../../constants';
import { useSelector } from 'react-redux';

/**
 * ConfirmMarkCompleteDialog - A reusable confirmation dialog for "Mark Complete" actions
 * 
 * @param {boolean} open - Whether the dialog is open
 * @param {function} onClose - Function to call when closing the dialog (Cancel)
 * @param {function} onConfirm - Function to call when confirming the action (Ok)
 * @param {string} title - Optional title for the dialog
 * @param {string} message - Optional custom message
 */
const ConfirmMarkCompleteDialog = ({
  open,
  onClose,
  onConfirm,
  title = "Confirm Mark Complete",
  message = "Are you Sure to Mark Complete This Vehicle"
}) => {
  const { scaleValue } = useResolutionScale();
  const themeMode = useSelector((state) => state?.theme?.themeMode);

  return (
    <ModalDialog
      open={open}
      title={title}
      onClose={onClose}
      modalWidth={scaleValue(700)}
      modalHeight="auto"
    >
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography
          variant="h5"
          sx={{
            mb: 4,
            fontWeight: 600,
            color: themeMode === DARK_MODE ? '#fff' : '#222',
            fontFamily: "'Uni Neue', sans-serif",
            fontSize: scaleValue(32)
          }}
        >
          {message}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 4 }}>
          <JlrButton
            variant="outlined"
            size="medium"
            onClick={onClose}
            sx={{ minWidth: scaleValue(140), width: 'auto' }}
          >
            Cancel
          </JlrButton>
          <JlrButton
            variant="primary"
            size="medium"
            onClick={onConfirm}
            sx={{ minWidth: scaleValue(140), width: 'auto' }}
          >
            Ok
          </JlrButton>
        </Box>
      </Box>
    </ModalDialog>
  );
};

export default ConfirmMarkCompleteDialog;
